import React, { Component } from 'react';


import { Col, Container, Row } from "reactstrap";

// Redux
import { connect } from 'react-redux';

// actions
import { apiError, checkLogin, forgetUser, requestOtpUser, resetLoginActionState, resetLoginState, setCurrentUser, switchUser, verify_admin } from '../../store/actions';

// import images
import { Alert, Avatar, Box, FormControlLabel, Grid, IconButton, Radio, Stack } from '@mui/material';
import Logo from '../../assets/images/Logo.png';
import LogoWhite from '../../assets/images/logo-white.png';
import LoadingDialog from '../../components/Common/LoadingDialog';
import withRouter from '../../components/Common/withRouter';
import CustomButton from '../../components/Form/CustomButton';
import CustomTextField from '../../components/Form/CustomTextField';
import loginBg from '../../assets/images/login-background.jpg';
import plane from '../../assets/images/sent-plane.png';
import Notification from '../../components/Common/Notification';
import { Icon } from '@iconify/react/dist/iconify.js';
import AppDialog from '../../components/Common/AppDialog';
class Login extends Component {

    constructor(props) {
        super(props);
        this.props.resetLoginState()
        this.state = {
            username: "",
            // username: "superadmin@app.com",
            password: "",
            loading: false,
            rememberMe: false,
            showPW: false,
            isPhone: true,
            isSent: false,
            isVerified: false,
            selectedAccount: null,
            resetOpen: false,

            notification: {
                open: false,
                msg: "",
                type: "success",
            },
            personalAccountList: [],
            dealerAccountList: [],
        }
        this.handleSubmit = this.handleSubmit.bind(this);
    }

    handleSubmit() {
        this.props.resetLoginState()
        this.setState({ loading: true });
        localStorage.setItem("remember", this.state.rememberMe);

        if (this.state.rememberMe) {
            localStorage.setItem("username", this.state.username);
        } else {
            localStorage.removeItem("username");
        }

        const values = {
            email: this.state.username,
            password: this.state.password,
        }
        this.props.checkLogin(values, this.props.router.navigate, this.state.rememberMe);
        // this.setState({ loading: false });
    }

    setNotification = (notification) => {
        this.setState({ notification: notification });
    }

    async componentDidMount() {
        this.props.apiError("");
        document.body.classList.add("auth-body-bg");
        // if (localStorage.getItem("remember") === "true") {
        //     this.setState({ username: localStorage.getItem("username"), rememberMe: true });
        // }
    }

    componentWillUnmount() {
        document.body.classList.remove("auth-body-bg");
    }

    componentDidUpdate(prevProps) {
        if (prevProps !== this.props) {
            if (this.props.loginError && this.props.loginError) {
                this.setState({ loading: false });
            }
            if (this.props.loginRes && this.props.loginRes?.code === "success") {
                this.props.resetLoginState();
                this.props.verify_admin();
                this.setState({ loading: false, isSent: false, isVerified: true, });
            }
            if (this.props.forgetPwd && this.props.forgetPwd?.code === "success" && !this.state.isSent) {
                this.props.resetLoginState();
                this.props.verify_admin();
                this.setState({ loading: false, isSent: true, resetOpen: false });
            }
            if (this.props.forgetPwd && this.props.forgetPwd?.code === "invalid_field") {
                this.setState({
                    loading: false,
                    error: this.props.forgetPwd?.errors,
                    notification: { open: true, msg: this.props.forgetPwd?.message || "Failed to send reset password email, please try again later", type: "error" }
                });
            }
            if (this.props.forgetPwd && this.props.forgetPwd?.code === "error") {
                this.setState({
                    loading: false,
                    error: null,
                    notification: { open: true, msg: this.props.forgetPwd?.data?.message || "Failed to send reset password email, please try again later", type: "error" }
                });
            }
        }
    }

    handleSubmitResetPwd() {
        // this.setState({ isSent: true, resetOpen: false })
        this.setState({ loading: true });
        this.props.forgetUser({ email: this.state.email })
    }

    render() {
        return (
            <React.Fragment>
                <div style={{ backgroundColor: '#F1F5F7', height: '100vh' }}>
                    <LoadingDialog open={this.state.loading} />
                    <Notification notification={this.state.notification} setNotification={this.setNotification} />
                    <Container fluid className="p-0">
                        <Grid container>
                            <Grid item md={8} sm={12} xs={12} style={{ backgroundColor: 'white' }}>
                                <div style={{ height: '100vh' }} className={this.props.currentWidth <= 768 ? '' : 'd-flex align-items-center justify-content-center'} onKeyDown={(e) => { if (e.key === 'Enter') this.handleSubmit() }}>
                                    <Box sx={{ minWidth: '50%', border: this.props?.currentWidth <= 768 ? '1px solid #E3E8EE' : 'none', borderRadius: 5 }} p={this.props?.currentWidth <= 768 ? 4 : 2} py={this.props?.currentWidth <= 768 && 6} m={this.props?.currentWidth <= 768 && 5}>
                                        <img src={Logo} style={{ height: '27px', objectFit: 'contain' }} />
                                        <div className={`text-bold font-size-24`} style={{ marginBlock: '35px' }}>
                                            Welcome back!
                                        </div>
                                        {this.props.loginError && this.props.loginError ?
                                            <Alert severity="error" className='my-2'>
                                                {
                                                    this.props.loginError?.code === 'invalid_password' ? 'Invalid credentials. Please try again.'
                                                    :this.props.loginError?.code === 'invalid_email' ? 'Invalid credentials. Please try again.'
                                                        : this.props.loginError?.errors?.email?.[0] || this.props.loginError?.errors?.password?.[0]
                                                }
                                            </Alert>
                                            : null
                                        }
                                        <CustomTextField
                                            values={this.state.username}
                                            variant="standard"
                                            error={this.props.message?.errors?.username}
                                            title={'Email Address'}
                                            onChange={(e) => this.setState({ username: e })}
                                            placeholder='Email address'
                                        />
                                        <div className='mt-2'>
                                            <CustomTextField
                                                placeholder='Enter your password'
                                                typePw={this.state.showPW ? 'text' : 'password'}
                                                title={"Password"}
                                                error={this.props.message?.errors?.password}
                                                values={this.state.password}
                                                onChange={(e) => this.setState({ password: e })}
                                                InputProps={{
                                                    endAdornment: <IconButton
                                                        aria-label="toggle password visibility"
                                                        onClick={(e) => this.setState({ showPW: !this.state.showPW })}
                                                        edge="end"
                                                    >
                                                        {this.state.showPW ? <Icon icon="ri:eye-line" width="24" height="24" /> : <Icon icon="ri:eye-close-line" width="24" height="24" />}
                                                    </IconButton>,
                                                }}
                                            />
                                        </div>
                                        <div className="mt-3 text-center">
                                            <CustomButton
                                                title={'Log in'}
                                                width={'100%'}
                                                padding={25}
                                                press={() => this.handleSubmit()}
                                            />
                                        </div>
                                        <div className="mt-4 text-center clickable" onClick={() => { this.setState({ resetOpen: true }) }}>Forgot Password?</div>
                                    </Box>
                                </div>
                            </Grid>
                            {
                                this.props?.currentWidth > 768 &&
                                <Grid item md={4} sm={0} xs={0} >
                                    <img src={loginBg} style={{ objectFit: 'cover', height: '100vh', width: '100%' }} />
                                </Grid>
                            }

                        </Grid>
                    </Container>
                </div>
                <AppDialog
                    open={this.state.resetOpen}
                    close={() => this.setState({ resetOpen: false })}
                    title={'Forgot your password?'}
                    width={'35%'}
                    positiveTitle={'Send reset link'}
                    positivePress={() => this.handleSubmitResetPwd()}
                    cancelButton={true}
                >
                    Enter your email address and we’ll send you a link to reset your password.
                    <div className='mt-3'>
                        <CustomTextField
                            values={this.state.email}
                            variant="standard"
                            error={this.state.error?.email}
                            title={'Email Address'}
                            onChange={(e) => this.setState({ email: e })}
                            placeholder='user@gmail.com'
                        />
                    </div>
                </AppDialog>
                <AppDialog
                    open={this.state.isSent}
                    close={() => this.setState({ isSent: false })}
                    title={'Check your inbox'}
                    width={'35%'}
                    positiveTitle={'Back to login'}
                    positivePress={() => this.setState({ isSent: false })}
                >
                    An email with a link to reset your password was sent to the email address associated with your account.
                    <div className='mt-3 d-flex justify-content-center'>
                        <img src={plane} alt='plane-img' style={{ height: 100, objectFit: 'contain' }} />
                    </div>
                </AppDialog>
            </React.Fragment >
        );
    }
}

const mapStatetoProps = state => {
    console.log("Login state: ", state.Forget);
    const { loginError, requestOtp, loginRes, verifyAdmin } = state.Login;
    const { currentWidth } = state.Layout;
    const { message } = state.Forget;

    return { loginError, requestOtp, loginRes, currentWidth, verifyAdmin, forgetPwd: message };
}

export default withRouter(connect(mapStatetoProps, { checkLogin, requestOtpUser, apiError, resetLoginState, resetLoginActionState, setCurrentUser, verify_admin, forgetUser })(Login));